// https://support.quantummetric.com/hc/en-us/articles/360016293373-Quantum-Metric-API
var timeout = function(ms, message) {
    if (message === void 0) message = "timeout";
    return new Promise(function(_, rej) {
        return setTimeout(function() {
            return rej(message);
        }, ms);
    });
};
var getQuantumMetricAPI = function() {
    return Promise.race([
        timeout(2000, "Timeout while attempting to get QuantumMetricAPI"),
        new Promise(function(resolve, reject) {
            var _window;
            if (typeof window === "undefined") {
                reject(new Error("Window undefined"));
            }
            if ((_window = window) == null ? void 0 : _window.QuantumMetricAPI) {
                resolve(window.QuantumMetricAPI);
            }
            window.addEventListener("QM-PAGE-READY", function() {
                var _window;
                if (!((_window = window) == null ? void 0 : _window.QuantumMetricAPI)) {
                    reject(new Error("QuantumMetricAPI undefined"));
                }
                resolve(window.QuantumMetricAPI);
            });
        })
    ]);
};
export default getQuantumMetricAPI;

//# sourceMappingURL=getQuantumMetricAPI.js.map